<template>
    <v-sheet class="treeview-container" flat>
        <v-treeview
            :items="items"
            item-key="id"
            item-text="title"
            item-children="treeChilds"
            :multiple-active="!selectable"
            :hoverable="!selectable"
            :activatable="selectable"
            @update:active="handleSelectIssue"
            transition>

            <template v-if="!selectable" v-slot:prepend="{ item }">
                <v-icon x-small>
                    label
                </v-icon>
            </template>
            <template v-if="!selectable" v-slot:label  ="{ item }">
                <v-layout align-center>
                    <label v-html="item.title"></label>
                    <v-spacer></v-spacer>
                    <v-btn small fab icon @click="handleEdit(item)"><v-icon small>edit</v-icon></v-btn>
                    <v-btn small fab icon @click="handleDelete(item)"><v-icon small>delete</v-icon></v-btn>
                </v-layout>
            </template>

        </v-treeview>
    </v-sheet>
</template>

<script>
    import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

    export default {
        props: {
            selectable: {
                type: Boolean,
                default: false
            },
            keyword: {
                type: String,
                default: ''
            },
            issues: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Home',
                        disabled: false,
                        href: config.PUBLIC_PATH
                    },
                    {
                        text: 'Issue',
                        disabled: true,
                        href: `${config.PUBLIC_PATH}/issue`
                    },
                ],
                avatar: null,
            }
        },
        computed: {
            items () {
                let keyword = (this.keyword || "")

                return  this.issues.filter(function f(o) {
                            if (o.title.toLowerCase().includes(keyword.toLowerCase()) || !keyword) return true

                            if (o.treeChilds) {
                                return !keyword || (o.treeChilds = o.treeChilds.filter(f)).length
                            }
                        })
            }
        },
        methods: {
            handleAdd () {
                this.$router.push({ path: `${config.PUBLIC_PATH}issue/new` })
            },
            handleEdit (issue) {
                this.$emit('edit', issue)
            },
            handleDelete (issue) {
                this.$emit('delete', issue)
            },
            handleSelectIssue (issueIds) {
                if ((issueIds || []).length) {
                    axios.get(`${config.BASE_URL}/issue/${issueIds[0]}`)
                        .then(response => {
                            this.$emit('select', response.data.data)
                        })
                }
            }
        },
    }
</script>

<style lang="scss">
    .v-btn {
        .v-icon {
            padding-right: 0 !important;
        }
    }
    .v-treeview-node__label {
        cursor: pointer;
    }
</style>